import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/service/data.service';

@Component({
  selector: 'app-causal-resultant-popup',
  templateUrl: './causal-resultant-popup.component.html',
  styleUrls: ['./causal-resultant-popup.component.scss']
})
export class CausalResultantPopupComponent implements OnInit {

  displayedColumns: string[] = ['No', 'causalMachine', 'causalDuration', 'machineLoss'];

  causalData: any = [];
  dataSource: any;
  tableColumns: any;
  tableView = false;
  unitSelected = 'cost';
  currencyRate = 1;
  currencySymbol: any = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialog: MatDialogRef<CausalResultantPopupComponent>,
    private dataSer: DataService
  ) {
    this.setData(data);
    this.tableColumns = ['No', 'Causal Machine', 'Resultant waste'];
  }

  ngOnInit() {
    this.dataSer.on('timeIntervalRefresh', this.timeIntervalDataChange);
  }

  setData(data) {
    let tempData = [];
    // let tempDurationArr = [];
    this.dataSource = [];
    this.causalData = [];

    if (data && data.popupData && data.popupData.causalMachineList) {
      // this.causalData = data;
      if (data.shiftOrThirty === '30 Minutes') {
        tempData = data.popupData.causalMachineList.thirtyMin.filter(thirtyMinData => thirtyMinData.machine === data.popupData.name);
      } else if (data.shiftOrThirty === 'Shift') {
        tempData = data.popupData.causalMachineList.shift.filter(shiftData => shiftData.machine === data.popupData.name);
      }
    } else {
      tempData = [];
    }

    // tempData.forEach((tempPopupData) => {
    //   tempPopupData.lossValue = parseFloat(tempPopupData.lossValue).toFixed(2);
    //   tempDurationArr = (tempPopupData.lossValue + '').split('.');
    //   if (tempDurationArr[1] > 59) {
    //     tempPopupData.lossValue = parseFloat(tempDurationArr[0]) + 1;
    //   }
    // });

    this.dataSource = tempData;
    this.causalData = tempData;

    if (data.costORqty) {
      this.unitSelected = data.costORqty;
    } else {
      this.unitSelected = 'cost';
    }

    if (data.currencyRate) {
      this.currencyRate = data.currencyRate;
    } else {
      this.currencyRate = 1;
    }

    if (data.currencySymbol) {
      this.currencySymbol = data.currencySymbol;
    } else {
      this.currencySymbol = '';
    }
  }

  dialogClose() {
    this.dialog.close();
  }

  timeIntervalDataChange = (newData: any) => {
    newData.forEach(currentData => {
      if (this.data && this.data.popupData && this.data.popupData.name && currentData.name &&
        this.data.popupData.name === currentData.name) {
        this.data.popupData = currentData;
        this.setData(this.data);
      }
    });
  }
}
